// extracted by mini-css-extract-plugin
export default {"fullscreenButton":"fullscreenButton_fullscreenButton__tGGlb","fullscreenButtonContainer":"fullscreenButton_fullscreenButtonContainer__FNlea"};